<template lang="html">
  <div id="products" class="productos--view productos">
    <intro></intro>

    <section :id="$t('productos.nav_options.junta_culata.id')" class="product-cat"
      :data="$t(`productos.shared['junta-culata']`)">
      <div class="cat-1 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat1">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/products/junta-culata-1.webp">
          <img class="w-100" src="/static/img/products/junta-culata-1.webp" :alt="$t('productos.alt_images.junta-culata-1')"
          :title="$t('productos.alt_images.junta-culata-1')" width="1648" height="1100">
        </picture>
        <div class="desc-cat flex column justify-center">
          <h2 class="title title-36">
            {{ $t("productos.junta_culata.titulo") }}
          </h2>
          <p v-html="$t('productos.junta_culata.texto')"></p>
          <!-- <a class="btn btn-dark btn-center" :href="getServer+ $t('productos.junta_culata.enlace_ficha_tecnica')" download>{{$t('productos.btn_ficha_tecnica')}}</a>
        <a class="btn btn-dark btn-center" target="_blank"  download>{{$t('productos.btn_ficha_seguridad')}}</a> -->
        </div>
        <div class="ver ver-responsive flex column justify-center">
          <router-link class="open-pop6 mas-light"
            :to="{ name: 'product', params: { id: $t('productos.nav_options.junta_culata.id') } }"></router-link>
          <!-- <rrss-share :data="$t(`productos.shared['junta-culata']`)"></rrss-share> -->
        </div>
      </div>
    </section>

    <section :id="$t('productos.nav_options.junta_motor.id')" class="product-cat"
      :data="$t(`productos.shared['junta-motor']`)">
      <div class="cat-2 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat2">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/products/portadas/junta-motor.webp">
          <img class="w-100" src="/static/img/products/portadas/junta-motor.webp"
          :alt="$t('productos.alt_images.junta-motor-1')" :title="$t('productos.alt_images.junta-motor-1')" width="1439" height="672" loading="lazy">
        </picture>
        <div class="desc-cat flex column justify-center">
          <h2 class="title title-36">
            {{ $t("productos.junta_motor.titulo") }}
          </h2>
          <p v-html="$t('productos.junta_motor.texto')"></p>
          <!-- <a class="btn btn-dark btn-center" :href="getServer+ $t('productos.junta_motor.enlace_ficha_tecnica')" download>{{$t('productos.btn_ficha_tecnica')}}</a>
        <a class="btn btn-dark btn-center" target="_blank"  download>{{$t('productos.btn_ficha_seguridad')}}</a> -->
        </div>
        <div class="ver ver-responsive column justify-center">
          <router-link class="open-pop6 mas-dark"
            :to="{ name: 'product', params: { id: $t('productos.nav_options.junta_motor.id') } }"></router-link>
          <!-- <rrss-share :data="$t(`productos.shared['junta-motor']`)"></rrss-share> -->
        </div>
      </div>
    </section>

    <section :id="$t('productos.nav_options.tornillos.id')" class="product-cat"
      :data="$t(`productos.shared['tornillos']`)">
      <div class="cat-3 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat3">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/products/tornillos-1.webp">
          <img class="w-100" src="/static/img/products/tornillos-1.webp" :alt="$t('productos.alt_images.tornillos-1')"
          :title="$t('productos.alt_images.tornillos-1')" width="1766" height="1179" loading="lazy">
        </picture>
        <div class="desc-cat flex column justify-center ">
          <h2 class="title title-36">{{ $t("productos.tornillos.titulo") }}</h2>
          <p v-html="$t('productos.tornillos.texto')"></p>
          <!-- <a class="btn btn-dark btn-center" :href="getServer+ $t('productos.tornillos.enlace_ficha_tecnica')" download>{{$t('productos.btn_ficha_tecnica')}}</a>
        <a class="btn btn-dark btn-center" target="_blank"  download>{{$t('productos.btn_ficha_seguridad')}}</a> -->
        </div>
        <div class="ver ver-responsive flex column justify-center">
          <router-link class="open-pop6 mas-dark"
            :to="{ name: 'product', params: { id: $t('productos.nav_options.tornillos.id') } }"></router-link>
          <!-- <rrss-share :data="$t(`productos.shared['tornillos']`)"></rrss-share> -->
        </div>
      </div>
    </section>

    <section :id="$t('productos.nav_options.retenes.id')" class="product-cat" :data="$t(`productos.shared['retenes']`)">
      <div class="cat-4 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat4">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/products/retenes-1.webp">
          <img class="w-100" src="/static/img/products/retenes-1.webp" :alt="$t('productos.alt_images.retenes-1')"
          :title="$t('productos.alt_images.retenes-1')" width="1766" height="1179" loading="lazy">
        </picture>
        <div class="desc-cat flex column justify-center">
          <h2 class="title title-36">{{ $t("productos.retenes.titulo") }}</h2>
          <p v-html="$t('productos.retenes.texto')"></p>
          <!-- <a class="btn btn-light btn-center " :href="getServer+ $t('productos.retenes.enlace_ficha_tecnica')" download>{{$t('productos.btn_ficha_tecnica')}}</a>
          <a class="btn btn-light btn-center " target="_blank"  download>{{$t('productos.btn_ficha_seguridad')}}</a> -->
        </div>
        <div class="ver ver-responsive column justify-center">
          <router-link class="open-pop6 mas-dark"
            :to="{ name: 'product', params: { id: $t('productos.nav_options.retenes.id') } }"></router-link>
          <!-- <rrss-share :data="$t(`productos.shared['retenes']`)"></rrss-share> -->
        </div>
      </div>
    </section>

    <section :id="$t('productos.nav_options.tubos_engrase.id')" class="product-cat"
      :data="$t(`productos.shared['tubos-engrase']`)">
      <div class="cat-5 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat5">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/products/tubos-engrase-1.webp">
          <img class="w-100" src="/static/img/products/tubos-engrase-1.webp"
          :alt="$t('productos.alt_images.tubos-engrase-1')" :title="$t('productos.alt_images.tubos-engrase-1')" width="1920" height="1282" loading="lazy">
        </picture>
        <div class="desc-cat flex column justify-center">
          <h2 class="title title-36">
            {{ $t("productos.tubos_engrase.titulo") }}
          </h2>
          <p v-html="$t('productos.tubos_engrase.texto')"></p>
          <!-- <a class="btn btn-dark btn-center" :href="getServer+ $t('productos.tubos_engrase.enlace_ficha_tecnica')" download>{{$t('productos.btn_ficha_tecnica')}}</a>
        <a class="btn btn-dark btn-center" target="_blank"  download>{{$t('productos.btn_ficha_seguridad')}}</a> -->
        </div>
        <div class="ver ver-responsive flex column justify-center">
          <router-link class="open-pop6 mas-dark"
            :to="{ name: 'product', params: { id: $t('productos.nav_options.tubos_engrase.id') } }"></router-link>
          <!-- <rrss-share :data="$t(`productos.shared['tubos-engrase']`)"></rrss-share> -->
        </div>
      </div>
    </section>

    <section :id="$t('productos.nav_options.tubos_egr.id')" class="product-cat"
        :data="$t(`productos.shared['tubos-egr']`)">
        <div class="cat-5 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat5">
          <img class="w-100" src="/static/img/products/tubos-egr-1.webp"
            :alt="$t('productos.alt_images.tubos-egr-1')" :title="$t('productos.alt_images.tubos-egr-1')" width="1766" height="1179" loading="lazy">
          <div class="desc-cat flex column justify-center">
            <h2 class="title title-36">
              {{ $t("productos.tubos_egr.titulo") }}
            </h2>
            <p v-html="$t('productos.tubos_egr.texto')"></p>
            <!-- <a class="btn btn-dark btn-center" :href="getServer+ $t('productos.tubos_engrase.enlace_ficha_tecnica')" download>{{$t('productos.btn_ficha_tecnica')}}</a>
        <a class="btn btn-dark btn-center" target="_blank"  download>{{$t('productos.btn_ficha_seguridad')}}</a> -->
          </div>
          <div class="ver ver-responsive flex column justify-center">
            <router-link class="open-pop6 mas-dark"
              :to="{ name: 'product', params: { id: $t('productos.nav_options.tubos_egr.id') } }"></router-link>
            <!-- <rrss-share :data="$t(`productos.shared['tubos-engrase']`)"></rrss-share> -->
          </div>
        </div>
      </section>

      <section :id="$t('productos.nav_options.tubos_refrigeracion.id')" class="product-cat"
      :data="$t(`productos.shared['tubos-refrigeracion']`)">
      <div class="cat-5 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat5">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/products/tubos-refrigeracion-1.webp">
          <img class="w-100" src="/static/img/products/tubos-refrigeracion-1.webp" :alt="$t('productos.alt_images.tubos-refrigeracion-1')"
          :title="$t('productos.alt_images.tubos-refrigeracion-1')" width="1344" height="768" loading="lazy">
        </picture>
        <div class="desc-cat flex column justify-center">
          <h2 class="title title-36">
            {{ $t("productos.tubos_refrigeracion.titulo") }}
          </h2>
          <p v-html="$t('productos.tubos_refrigeracion.texto')"></p>
          <!-- <a class="btn btn-dark btn-center" :href="getServer+ $t('productos.tubos_engrase.enlace_ficha_tecnica')" download>{{$t('productos.btn_ficha_tecnica')}}</a>
        <a class="btn btn-dark btn-center" target="_blank"  download>{{$t('productos.btn_ficha_seguridad')}}</a> -->
        </div>
        <div class="ver ver-responsive flex column justify-center">
          <router-link class="open-pop6 mas-dark"
            :to="{ name: 'product', params: { id: $t('productos.nav_options.tubos_refrigeracion.id') } }"></router-link>
          <!-- <rrss-share :data="$t(`productos.shared['tubos-engrase']`)"></rrss-share> -->
        </div>
      </div>
    </section>

    <section :id="$t('productos.nav_options.junta_turbo.id')" class="product-cat"
      :data="$t(`productos.shared['junta-turbo']`)">
      <div class="cat-6 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat6">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/products/junta-turbo-1.webp">
          <img class="w-100" src="/static/img/products/junta-turbo-1.webp" :alt="$t('productos.alt_images.junta-turbo-1')"
          :title="$t('productos.alt_images.junta-turbo-1')" width="1498" height="1000" loading="lazy">
        </picture>
        <div class="desc-cat flex column justify-center">
          <h2 class="title title-36">
            {{ $t("productos.junta_turbo.titulo") }}
          </h2>
          <p v-html="$t('productos.junta_turbo.texto')"></p>
          <!-- <a class="btn btn-dark btn-center" :href="getServer+ $t('productos.junta_turbo.enlace_ficha_tecnica')" download>{{$t('productos.btn_ficha_tecnica')}}</a>
        <a class="btn btn-dark btn-center" target="_blank"  download>{{$t('productos.btn_ficha_seguridad')}}</a> -->
        </div>
        <div class="ver ver-responsive column justify-center">
          <router-link class="open-pop6 mas-dark"
            :to="{ name: 'product', params: { id: $t('productos.nav_options.junta_turbo.id') } }"></router-link>
          <!-- <rrss-share :data="$t(`productos.shared['junta-turbo']`)"></rrss-share> -->
        </div>
      </div>
    </section>

    <section :id="$t('productos.nav_options.productos_quimicos.id')" class="product-cat"
      :data="$t(`productos.shared['productos_quimicos']`)">
      <div class="cat-7 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat7">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/productos-quimicos/main-quimicos.webp">
          <img class="w-100" src="/static/img/productos-quimicos/main-quimicos.webp"
          :alt="$t('productos.alt_images.sellantes_lubricantes')"
          :title="$t('productos.alt_images.sellantes_lubricantes')" width="1920" height="871" loading="lazy">
        </picture>
        <div class="desc-cat flex column justify-center">
          <h2 class="title title-36">{{ $t("productos.productos_quimicos.titulo") }}</h2>
          <p v-html="$t('productos.productos_quimicos.texto')"></p>
          <div class="pdf-info flex row justify-center">

          </div>
        </div>
        <div class="ver ver-responsive column justify-center">
          <!-- Lleva prefijo de idioma: sin el, `beforeEach` tiene que inyectarlo y
               el clic pasa por una redireccion intermedia. -->
          <router-link class="open-pop6 mas-dark" :to="`/${$i18n.locale}/${$t('enlaces.productos_quimicos')}`"></router-link>
          <!-- <rrss-share :data="$t(`productos.shared['junta-turbo']`)"></rrss-share> -->
        </div>
      </div>
    </section>



    <!-- ----------- -->
    <section :id="$t('productos.nav_options.taques.id')" class="product-cat" :data="$t(`productos.shared['taques']`)">
      <div class="cat-9 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat9">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/products/taques-1.webp">
          <img class="w-100" src="/static/img/products/taques-1.webp" :alt="$t('productos.alt_images.taques-1')"
          :title="$t('productos.alt_images.taques-1')" width="1498" height="1000" loading="lazy">
        </picture>
        <div class="desc-cat flex column justify-center">
          <h2 class="title title-36">{{ $t("productos.taques.titulo") }}</h2>
          <p v-html="$t('productos.taques.texto')"></p>
          <!-- <a class="btn btn-dark btn-center" :href="getServer+ $t('productos.taques.enlace_ficha_tecnica')" download>{{$t('productos.btn_ficha_tecnica')}}</a>
        <a class="btn btn-dark btn-center" target="_blank"  download>{{$t('productos.btn_ficha_seguridad')}}</a> -->
        </div>
        <div class="ver ver-responsive column justify-center">
          <router-link class="open-pop6 mas-dark"
            :to="{ name: 'product', params: { id: $t('productos.nav_options.taques.id') } }"></router-link>
          <!-- <rrss-share :data="$t(`productos.shared['taques']`)"></rrss-share> -->
        </div>
      </div>
    </section>

    <section :id="$t('productos.nav_options.arbol_levas.id')" class="product-cat"
      :data="$t(`productos.shared['arbol-levas']`)">
      <div class="cat-10 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat10">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/products/arbol-levas-1.webp">
          <img class="w-100" src="/static/img/products/arbol-levas-1.webp" :alt="$t('productos.alt_images.arbol-levas-1')"
          :title="$t('productos.alt_images.arbol-levas-1')" width="1498" height="1000" loading="lazy">
        </picture>
        <div class="desc-cat flex column justify-center">
          <h2 class="title title-36">
            {{ $t("productos.arbol_levas.titulo") }}
          </h2>
          <p v-html="$t('productos.arbol_levas.texto')"></p>
          <!-- <a class="btn btn-dark btn-center" :href="getServer+ $t('productos.arbol_levas.enlace_ficha_tecnica')" download>{{$t('productos.btn_ficha_tecnica')}}</a>
        <a class="btn btn-dark btn-center" target="_blank"  download>{{$t('productos.btn_ficha_seguridad')}}</a> -->
        </div>
        <div class="ver ver-responsive flex column justify-center">
          <router-link class="open-pop6 mas-dark"
            :to="{ name: 'product', params: { id: $t('productos.nav_options.arbol_levas.id') } }"></router-link>
          <!-- <rrss-share :data="$t(`productos.shared['arbol-levas']`)"></rrss-share> -->
        </div>
      </div>
    </section>

    <section :id="$t('productos.nav_options.otros.id')" class="product-cat" :data="$t(`productos.shared['otros']`)">
      <div class="cat-11 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat11">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/products/otros-1.webp">
          <img class="w-100" src="/static/img/products/otros-1.webp" :alt="$t('productos.alt_images.otros-1')"
          :title="$t('productos.alt_images.otros-1')" width="1766" height="1179" loading="lazy">
        </picture>
        <div class="desc-cat flex column justify-center">
          <h2 class="title title-36">{{ $t("productos.otros.titulo") }}</h2>
          <p v-html="$t('productos.otros.texto')"></p>
          <!-- <a class="btn btn-dark btn-center" :href="getServer+ $t('productos.otros.enlace_ficha_tecnica')" download>{{$t('productos.btn_ficha_tecnica')}}</a>
        <a class="btn btn-dark btn-center" target="_blank"  download>{{$t('productos.btn_ficha_seguridad')}}</a> -->
        </div>
        <div class="ver ver-responsive column justify-center">
          <router-link class="open-pop6 mas-dark"
            :to="{ name: 'product', params: { id: $t('productos.nav_options.otros.id') } }"></router-link>
          <!-- <rrss-share :data="$t(`productos.shared['otros']`)"></rrss-share> -->
        </div>
      </div>
    </section>

    <!-- POPUP PDF SEGURIDAD -->
    <popupPdfSeguridad v-show="show_popup_pdf" :id="producto" :type="type" :show_popup_pdf.sync="show_popup_pdf">
    </popupPdfSeguridad>

    <!-- ---- -->
    <section class="popup" v-show="show_popup">
      <div class="wrapper-gallery">
        <div class="imagen--container flex column justify-center">
          <!--
            `v-if` en lugar de renderizar siempre: `img_big` arranca vacio, y el
            popup se monta oculto con v-show. Sin esta condicion la etiqueta
            quedaba en el DOM con src="/static/img/products/.webp" (peticion que
            responde 404) y alt="productos.alt_images.", la clave sin resolver.
          -->
          <img v-if="img_big" :src="`/static/img/products/${img_big}.webp`" :alt="$t(`productos.alt_images.${img_big}`)"
            :title="$t(`productos.alt_images.${img_big}`)" class="custom" @click="closePop" />
        </div>
        <ul class="thumbnails">
          <li @click="setImage(`${how}-${key + 1}`)" v-for="(i, key) in fotos[how]">
            <img :src="`/static/img/products/${how}-${key + 1}.webp`"
              :alt="$t(`productos.alt_images.${how}-${key + 1}`)" />
          </li>
        </ul>
      </div>
    </section>

    <section class="garantia sec-center pad-sec">
      <div class="container waypoints" data="fadeInUp">
        <div v-html="$t('productos.garantia.titulo1')"></div>
        <p>{{ $t("productos.garantia.texto") }}</p>

        <a class="btn btn-dark" target="_blank" :href="$t('enlaces.productos_certificados_calidad')">{{
          $t("productos.garantia.boton") }}</a>
        <p>{{ $t('productos.garantia.cumplimiento') }}</p>
      </div>
    </section>

    <otras-secciones :data="['catalogo', 'area_tecnica']"></otras-secciones>
  </div>
</template>

<script lang="js">

import Intro from '@/components/view-parts/intros/productos'

import Otras_Secciones from '@/components/parts/acceso-a-secciones';
import rrssShare from '@/components/parts/rrss-share';
import popupPdfSeguridad from '@/components/view-parts/popup-pdf-seguridad';
import { mapGetters } from 'vuex';


export default {
  name: 'productos',
  props: [],
  mounted() {
    let to = this.$route.params.id;
    if ($(".product-cat[data='" + to + "']").length > 0) {
      $('body,html').animate({ scrollTop: $(".product-cat[data='" + to + "']").position().top }, 800);
    }

    if ($("#" + to).length > 0) {
      this.scrollTo(to);
    }

    // El intercambio por la version reducida lo hace ahora el atributo `srcset`
    // de cada <img>. Antes se sustituia aqui el `src`, ya renderizada la pagina,
    // cuando el navegador ya habia empezado a descargar la version grande.
  },
  data() {
    return {
      show_popup: false,
      show_popup_pdf: false,
      producto: '',
      fotos: {
        'junta-turbo': 4,
        'ajusil': 4,
        'nuevo_sellante': 5,
        'arbol-levas': 4,
        'junta-culata': 3,
        'junta-motor': 5,
        'otros': 4,
        'retenes': 4,
        'taques': 4,
        'tornillos': 4,
        'tubos-engrase': 4
      },
      how: '',
      img_big: '',
      type: ''
    }
  },
  methods: {
    show: function (value) {
      this.how = value;
      this.show_popup = true;
      this.img_big = `${value}-1`;
    },
    show_pdf: function (value) {
      this.producto = value[0];
      this.type = value[1];
      this.show_popup_pdf = true;
    },
    setImage: function (value) {
      this.img_big = value;
    },
    closePop: function () {
      this.show_popup = false;
      this.show_popup_pdf = false;
    },
    updateScore(newValue) {
      this.score = newValue  // 3.Updating
      console.log(newValue)
    },
    scrollTo(to) {
      if ($("#" + to).length > 0) {
        $('body,html').animate({ scrollTop: $("#" + to).position().top }, 800);
      }
    }
  },
  computed: {
    ...mapGetters(['getServer', 'getLanguage']),
  },
  components: {
    'intro': Intro,
    'otras-secciones': Otras_Secciones,
    'rrss-share': rrssShare,
    'popupPdfSeguridad': popupPdfSeguridad
  },
  watch: {
    "$route.params.id"() {
      this.scrollTo(this.$route.params.id);
    }
  },
}
</script>

<style scoped>
.popup {
  display: inline-block;
}

.imagen--container {
  max-width: 100%;
  max-height: 100%;
}

.imagen--container img {
  max-width: 100%;
  max-height: 100%;
}

.btn-dark {
  margin-top: 10px;
  background: #E6007E;
  border-color: #E6007E;
  color: white;
}

.btn-center {
  margin: 10px 0;
  padding: 4px;
  font-size: 16px;
}

.btn-center.btn-info {
  max-width: 330px;
  border: 1px solid #054279;
  color: #054279;
  font-size: 12px;
  padding: 7px 0;
  font-weight: bold;
  line-height: 20px;
}

section[data="ajusil"] .btn-center.btn-info:hover {
  background: #E6007E;
  color: white;
}

.btn-center.btn-info:hover {
  background: #FFED00;
  color: #054279;
}

.btn-center.btn-info:first-child {
  margin-right: 29px;
}

@media only screen and (max-width: 650px) {

  .ver.ver-responsive,
  .product-cat:nth-of-type(2n):hover .ver.ver-responsive {
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  .btn-light {
    color: #054279;
    border-color: #054279;
  }

  .pdf-info {
    flex-direction: column;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/productos.vue